import { ImageLoaderProps } from "next/image";

const imageLoader = ({ src, width, quality }: ImageLoaderProps) => {
  if (/^https?:\/\//.test(src)) {
    const url = new URL(src);

    url.searchParams.set("fm", "auto");
    url.searchParams.set("width", width.toString());
    url.searchParams.set("quality", (quality || 90).toString());

    return url.href;
  }

  return src;
};

export default imageLoader;
